import type { FC } from 'react';

import { Fade, Typography, styled } from '@mui/material';
import { colors } from '@truvhq/ui';
import clsx from 'clsx';

import { useSandboxContext } from 'contexts/SandboxContext';

import SandboxHeaderSvg from './sandbox_header.svg';

const SandboxHeaderLine = styled('div')({
  backgroundColor: colors.primary.main,
  minWidth: 197,
});

const SandboxHeaderLabel = styled('div')({
  width: 158,
  height: 32,
  backgroundImage: `url(${SandboxHeaderSvg})`,
  backgroundRepeat: 'no-repeat',
});

type SandboxHeaderProps = {
  absolute?: boolean;
};

export const SandboxHeader: FC<SandboxHeaderProps> = ({ absolute }) => {
  const { isSandboxOn } = useSandboxContext();

  if (!isSandboxOn) {
    return null;
  }

  return (
    <Fade in={isSandboxOn} timeout={600}>
      <div
        className={clsx('pointer-events-none flex w-full flex-col items-center', {
          'absolute z-20': absolute,
        })}
        data-testid="sandbox-header"
      >
        <SandboxHeaderLine className="h-0.5 w-full" />
        <SandboxHeaderLabel className="mt-[-1px] flex items-center justify-center">
          <Typography className="whitespace-nowrap font-medium text-white" variant="body2">
            Sandbox mode
          </Typography>
        </SandboxHeaderLabel>
      </div>
    </Fade>
  );
};
